//import { VisualCrossingConstants } from "./commonobjects";
import {VcGlobal} from "./vcglobal_conn";
import {VcLocationsStorage} from "./vclocationsstorage";
import {VcListUtils} from './vclistutils';

console.log("VcCommunicator Class")
export function VcCommunicator(config) {
    this.config=config;
    this.sessionId=null;
    this.sessionState=null;
    this.isInited=false;
    this.gclid=null;
    this.gtagclient_id=null;
    this.gtagsession_id=null;
    this.init();
};

/*
VcCommunicator.prototype.HTTP_REQUEST_MULTIPART_NAME_VC_UPLOAD_INFO = "VC-Upload-Info";
VcCommunicator.prototype.HTTP_REQUEST_MULTIPART_NAME_VC_UPLOAD_CONTENT = "VC-Upload-Content";
*/
VcCommunicator.prototype.init=function() {
    var me=this;
    me.isInited=false;
    console.log("Starting vc communicator instance")

    
    // Grab gclid synchronously: URL param (landing page) or _gcl_aw cookie (subsequent pages)
    try {
        const url = window.location && new URL(window.location.href);
        const searchParams = url && url.searchParams;
        me.gclid = searchParams && searchParams.get('gclid');
        if (!me.gclid) {
            // _gcl_aw cookie format: "GCL.timestamp.gclid"
            const gclMatch = document.cookie.match(/(?:^|;\s*)_gcl_aw=GCL\.\d+\.([^;]+)/);
            if (gclMatch) me.gclid = gclMatch[1];
        }
    } catch (e) { /* swallow */ }

    // Fire pt promptly — don't wait for gtag
    me.deferPageTrack();

    // Let gtag callbacks populate values whenever they arrive (no timeout).
    // These values are used on later API calls (ginfo param), not pt.
    if (window["gtag"]) {
        try {
            gtag('get', 'G-MFKKR9DRRN', 'gclid', (val) => {
                if (val) me.gclid = val; // prefer gtag gclid over URL param
            });
            gtag('get', 'G-MFKKR9DRRN', 'client_id', (val) => {
                me.gtagclient_id = val;
            });
            gtag('get', 'G-MFKKR9DRRN', 'session_id', (val) => {
                me.gtagsession_id = val;
            });
        } catch (e) { /* swallow */ }
    }

    var sessionId=me.getCookie('sessionId');
    // && sessionId===window.vcSessionState.sessionId
    if (window.vcSessionState) {
        console.log("Found a matching vcSessionState");
        
        me.sessionId=window.vcSessionState.sessionId;
        me.sessionState=window.vcSessionState;
        me.setCookie('sessionId', window.vcSessionState.sessionId,0, 60);
        console.log("createsession - dispatched")
        me.dispatchEvent('createsession',me.sessionId,me.sessionState  );
        me.isInited=true;
        return;
    }


    me.serverinfo().then(function (response) {
        
        console.log("Connected to the a vc server..."+sessionId);
        if (sessionId) {
           
            me.createsession(null,null, true, sessionId)
                .then(function (response) {
                    me.sessionId=sessionId;
                    me.isInited=true;
                    console.log("Attached to a session...");
                }).catch((error) => {
                    console.log(error);
                    me.sessionId=null;
                    me.isInited=true;
                    me.deleteCookie('sessionId');
                });
        } else {
            me.isInited=true;
            console.log("No session id to connect");
            me.dispatchEvent('createsession',null,null);
            // me.dispatchEvent('createsessionfailed',"No existing session id"); 
            return;
        }
    }).catch((error) => {
        console.log(error);
        me.dispatchEvent('createsessionfailed',"Unknown error occurred"); 
    });


}

VcCommunicator.prototype.deferPageTrack = function(extraInfo, delay = 1500) {
  const me = this;
  const run = () => {
    try { me.pageTrack(extraInfo); } catch (e) { /* swallow analytics errors */ }
  };
  if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(run, { timeout: Math.max(500, delay) });
  } else {
    setTimeout(run, delay);
  }
};
VcCommunicator.prototype.pageTrack = function(extraInfo) {
    let path = window.location.pathname;
    let params = window.location.search;
    if (params) path = path + params;
    if (extraInfo) path = path + "|" + extraInfo;

    const ginfo = (this.gclid||"")+"||"+(this.gtagclient_id||"")+"||"+(this.gtagsession_id||"")+"||"+VcLocationsStorage.getCid();
    const payload = new URLSearchParams({ p: path, ginfo: ginfo }).toString();
    const url = this.createUrl("pt");

    try {
        if (navigator && typeof navigator.sendBeacon === 'function') {
            const blob = new Blob([payload], { type: 'application/x-www-form-urlencoded' });
            navigator.sendBeacon(url, blob);
            return;
        }
    } catch (e) {
        // swallow and fallback
    }

    // fallback: non-blocking fetch with keepalive if available
    try {
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: payload,
            keepalive: true,
            mode: 'cors'
        }).catch(()=>{ /* swallow */ });
    } catch (e) {
        /* swallow */
    }
};

VcCommunicator.prototype.getUserInfo=function(callback) {
    let me=this;
    function processResolve(sessionState) {
        if (!sessionState || !sessionState.subscriptionParams) {
            callback(null);

           
            return;
        }

        const userInfo={
            email:sessionState.subscriptionParams.custEmail,
            apikey:sessionState.apiKey,
        };

        

        callback(userInfo);


    }

    if (me.sessionState) {
        processResolve(me.sessionState);
    }

    me.addHandler('createsession', function (sessionId,sessionState) {
        processResolve(me.sessionState);
    });
     me.addHandler('terminatesession', function () {
        processResolve(null); 
    });  
}





VcCommunicator.prototype.addHandler=function(type, handler) {
    var me=this;
    me.handlers=me.handlers || {};
    me.handlers[type]=(me.handlers[type] || []);
    me.handlers[type].push(handler)
}

VcCommunicator.prototype.dispatchEvent=function(type, ...params) {
    var me=this;
    me.handlers && me.handlers[type] && me.handlers[type].forEach(function(f) {
        f(...params);
    })
}
VcCommunicator.prototype.deleteCookie=function(cname) {
    this.setCookie(cname, "", -30);
}

VcCommunicator.prototype.setCookie=function(cname, cvalue, exdays) {
    if (!exdays) exdays=30;
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};
/*
VcCommunicator.prototype.setCookie = function(cname, cvalue, exdays = 30) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    
    document.cookie = `${cname}=${cvalue}; ${expires}; path=/; Secure;`; //SameSite=Strict
};
*/
VcCommunicator.prototype.getCookie=function(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
        c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
        }
    }
    return "";
};



VcCommunicator.prototype.retrieveData=function(url,data, contentType, method, extraHeaders) {
    var me=this;
   
    method=method || 'POST';
    contentType=contentType || (method==="POST"?'application/x-www-form-urlencoded':'application/json');

    data=data || {};

    //prune nulls because they get passed as 'null' text
    Object.keys(data).forEach(function(d) {
        (data[d] === null || data[d] === undefined) && delete data[d];
    });

    //console.log("Retrieve data:"+me.sessionId)
    if (me.sessionId) {
        data.sessionId=me.sessionId;
    }

    let gtag=(me.gclid?me.gclid:"")+"||"+(me.gtagclient_id?me.gtagclient_id:"")+"||"+(me.gtagsession_id?me.gtagsession_id:"")+"||"+VcLocationsStorage.getCid();
    if (gtag) {
        data.ginfo=gtag;
    }



    if (contentType==='application/x-www-form-urlencoded') {
        data = new URLSearchParams(data);
    } else if (contentType==='multipart') {
        contentType=null
    } else if (contentType==='application/json') {
        if (method!=="GET") {
            data=JSON.stringify(data);
        }
    } else {

    }

    if (method==="GET") {
        data = new URLSearchParams(data);
        url=url+"?"+data.toString();
        data=null;
    }


    // Store the original request context for potential retry after 2FA
    const originalRequest = {
        url: url,
        data: data,
        contentType: contentType,
        method: method,
        originalData: data // Keep original data before transformation
    };

    return new Promise((resolve, reject) => {
        const headers = { 'Content-Type': contentType };
        if (extraHeaders) {
            Object.assign(headers, extraHeaders);
        }
        fetch(url, {
            method: method, 
            mode: 'cors',
            cache: 'no-cache', 
            headers: headers,
            redirect: 'follow',
            referrerPolicy: 'strict-origin-when-cross-origin',
            body: data
        }).then(response => {

            // Check if it's a 2FA required response (status 428 - Precondition Required)
            if (response.status === 428) {
                return response.json().then(responseData => {
                    if (responseData.requires2FA) {
                        // Trigger 2FA flow
                        return me.handle2FARequired(originalRequest, responseData).then(result => {
                            // Return the result so the promise chain continues properly
                            return result;
                        }).catch(error => {
                            // Re-throw to be caught by outer catch
                            console.error("2FA handling error:", error);
                            throw error;
                        });
                    }
                    throw response;
                });
            }

            if (!response.ok) {
               // if (!response.ok) throw new Error("Error retrieving the data ("+response.status+")");
               throw response;
            }
            
            return response.json();
        }).then(response => {

            if (response.errorCode) {
                reject(response.message || "Unexpected error "+response.errorCode);
                return;
            }
           resolve(response);
        
        }).catch((errorResponse) => {
           // console.log(errorResponse) 
            if (errorResponse.text) {
                errorResponse.text().then( errorMessage => {
                    reject(errorMessage);
                })
            } else {
                reject("An error occurred retrieving the data");
            }  
        });
    });
   

}

// Add new method to handle 2FA
VcCommunicator.prototype.handle2FARequired = function(originalRequest, responseData) {
    var me = this;
    
    return new Promise((resolve, reject) => {
        // Check if we have a global 2FA service (not component)
        if (window.twoFactorService) {
            // The twoFactorService will handle showing the modal and returning the result
            window.twoFactorService.show2FAModal({
                sessionId: me.sessionId,
                originalRequest: originalRequest,
                responseData: responseData
            }).then(result => {
                // The service has already retried the request
                resolve(result);
            }).catch(error => {
                reject(error);
            });
        } else {
            // Fallback: dispatch event for any listeners
            if (me.eventHandlers && me.eventHandlers['requires2FA']) {
                me.eventHandlers['requires2FA'].forEach(handler => {
                    handler(originalRequest, responseData);
                });
            }
            reject(new Error('Two-factor authentication required'));
        }
    });
}

// Retry request after successful 2FA
VcCommunicator.prototype.retryRequestAfter2FA = function(originalRequest) {
    var me = this;
    
    // Reconstruct the data with updated session
    let data = originalRequest.originalData;
    let reconstructedData = {};
    
    if (typeof data === 'string') {
        try {
            // Try to parse as JSON
            reconstructedData = JSON.parse(data);
        } catch (e) {
            // If it's URLSearchParams string, parse it
            const params = new URLSearchParams(data);
            for (const [key, value] of params) {
                reconstructedData[key] = value;
            }
        }
    } else if (data instanceof URLSearchParams) {
        // Convert URLSearchParams back to object
        for (const [key, value] of data) {
            reconstructedData[key] = value;
        }
    } else if (data instanceof FormData) {
        // FormData needs special handling
        // We'll need to reconstruct it
        reconstructedData = new FormData();
        // Note: We can't iterate FormData in older browsers
        // This is a limitation - we'd need to store the original object data
        return me.retrieveData(originalRequest.url, data, originalRequest.contentType, originalRequest.method);
    } else {
        // Already an object
        reconstructedData = data || {};
    }
    
    // Update session ID if we have one
    if (me.sessionId) {
        reconstructedData.sessionId = me.sessionId;
    }
    
    // Retry the request with updated data
    return me.retrieveData(originalRequest.url, reconstructedData, originalRequest.contentType, originalRequest.method);
}

/*
VcCommunicator.prototype.retrieveDataMultiPart=function(url, textInfo, text,callback) {
    if (!textInfo) textInfo={};
    textInfo=JSON.stringify(textInfo);

    var boundary = "VC_UPLOAD_BOUNDARY";
    while (text.indexOf (boundary)!==-1 || textInfo.indexOf (boundary)!==-1) {
        boundary = "VC_UPLOAD_BOUNDARY" + (new Date().getTime());
    }
   
    var buffer = "--"+boundary+"\r\n";
    buffer+="Content-Disposition: form-data; name=\"" + VcCommunicator.prototype.HTTP_REQUEST_MULTIPART_NAME_VC_UPLOAD_INFO + "\"\r\n\r\n";
    buffer+=textInfo+"\r\n";
    buffer+="--"+boundary+"\r\n";
    buffer+="Content-Disposition: form-data; name=\"" + VcCommunicator.prototype.HTTP_REQUEST_MULTIPART_NAME_VC_UPLOAD_CONTENT + "\"\r\n\r\n";
    buffer+=text+"\r\n";
    buffer+="--"+boundary+"--\r\n";



    var request = $.ajax({
        url: url,
        data: buffer,
        cache: false,
        contentType: "multipart/form-data; charset=UTF-8; boundary="+boundary,
        processData: false,
        method: "POST"
    });
    
    request.done(function( data ) {
        callback.done(data);
    });
    
    request.fail(function( jqXHR, textStatus ) {
        if (callback.fail) callback.fail(textStatus);
    });
}

VcCommunicator.prototype.processObject=function(metadata,data,callback) {
    var me=this;
    var url=this.createUrl("processobject", null);
    
    var textInfo = {
        metadata:metadata.toJson(),
        sessionId:me.sessionId
    };

    var dataText=(typeof data === 'string' || data instanceof String)?data:JSON.stringify(data);

    me.retrieveDataMultiPart(url, textInfo, dataText,{
        "done":function(data) {
            me.checkJobResponse(data, callback);
        },

        "fail":function(data) {
            callback.fail("Request failed: "+data);
        }
    
    });
}

VcCommunicator.prototype.checkJobResponse=function(response,callback) {
    var me=this;
    response=(typeof response === 'string' || response instanceof String)?JSON.parse(response):response;
    if (response.errorCode) {
        callback.fail(response.message || "Request failed", response.errorCode);
        return;
    }
    var metadata, requestMetadata, result;
    if (response.info) {
        metadata = new Metadata (response.info);
    }
    if (response.requestInfo){
        requestMetadata = new Metadata (response.requestInfo);
    }

    if (response.dataJson) {
        result=response.dataJson;
    } else if (response.dataTextCompressed)   {
        callback.fail("Data text compressed result not support", -999); 
    } else if (response.dataText) {
        result=response.dataText;
    }
    
    if (result) {
        callback.done(result,metadata, requestMetadata );
        return;
    }


    if (!response.status) {
        callback.fail("Unsupported response format", -999); 
        return;
    }
    if (VisualCrossingConstants.JOB_STATUS.isComplete(response.status)) {
        //callback.done(response.result);
        me.checkJobResponse(response.result, callback);
        return;
    }
    if (VisualCrossingConstants.JOB_STATUS.isError(response.status)) {
        callback.fail(response.info || "Request failed", -999); 
        return;
    }
    if (VisualCrossingConstants.JOB_STATUS.isExecuting(response.status)) {
        if (callback.update) callback.update(response.info); 
        setTimeout(function() {
            me.checkJobStatus(response.id, callback);
        }, 500);
        return;
    }

}


VcCommunicator.prototype.checkJobStatus=function(jobId, callback) {
    var me=this;

    var requestPackage=this.config.createsessionpkg || {};

    this.retrieveData(this.createUrl("getjobstatus",[jobId]), requestPackage, {
        "done":function(data) {
            me.checkJobResponse(data, callback);
        },

        "fail":function(data) {
            callback.fail("Check job status request failed");
        }
    
    });
}
*/

VcCommunicator.prototype.createUrl=function(method, pathparams, serverRoot) {
    serverRoot=serverRoot || this.config.serverroot;
    var url=serverRoot+method;
    if (pathparams) {
        pathparams.forEach(function(d) {
            url+="/"+d;
        });
    }
    return url;
}
VcCommunicator.prototype.serverinfo=function() {
    var me=this;
    return this.retrieveData(this.createUrl("serverinfo"), null);
}

VcCommunicator.prototype.waitForSession=function(callback) {
    var me=this;
    me.addHandler('createsession', function(sessionId,sessionState) {
        callback(me.sessionState); 
        return;
    });

    me.addHandler('createsessionfailed', function(error) {
        callback(null, error); 
    });

    


    if (me.sessionState) {
        callback(me.sessionState); 
        return;
    }
   
}
VcCommunicator.prototype.waitForTerminateSession=function(callback) {
    var me=this;

    me.addHandler('terminatesession', function() {
        callback();
        return;
    });
}
/*
VcCommunicator.prototype.waitForSession=function() {
    var me=this;

    return new Promise((resolve, reject) => {
        if (!me.sessionId) {
            reject("No existing session id"); 
            return;
        }


        if (me.sessionState) {
            resolve(me.sessionId, me.sessionState);
            return;
        }
        me.addHandler('createsession', function(sessionId,sessionState) {
            resolve(sessionState, sessionId);
            return;
        });

        me.addHandler('createsessionfailed', function(error) {
            reject(error); 
        });
    });
}
VcCommunicator.prototype.waitForTerminateSession=function() {
    var me=this;

    return new Promise((resolve, reject) => {
       
        me.addHandler('terminatesession', function() {
            resolve();
            return;
        });

    });
}
*/
VcCommunicator.prototype.createsession=function(username, password, recreateSession, existingSessionId) {
    var me=this;
    console.log("createsession - start")
    
    var requestPackage = {};
    if (this.config.createsessionpkg) {
        Object.keys(this.config.createsessionpkg).forEach(function(key) {
            requestPackage[key] = me.config.createsessionpkg[key];
        });
    }

    if (!username) {
        requestPackage.existingSessionId=existingSessionId || me.sessionId;
        requestPackage.recreateSession=recreateSession;
    } else {
        requestPackage.userId=username;
        requestPackage.userName=username;
        requestPackage.pwd=password;
    }
    requestPackage.nostate=true;
    requestPackage.v=VcGlobal.VERSION;

    // Send stored device token for 2FA device authorization
    var storedDeviceToken = VcLocationsStorage.getValue('vc2FADeviceToken');
    if (storedDeviceToken) {
        requestPackage.deviceToken = storedDeviceToken;
    }
    return new Promise((resolve, reject) => {
        this.retrieveData(this.createUrl("createsession"), requestPackage)
            .then(data => {
                if (data.errorCode || !data.sessionId) {
                    console.log("createsession - no sessionId")
                    reject(data.message || "Log in failed");
                    return;
                }
                me.sessionId=data.sessionId;
                me.sessionState=data;
                me.setCookie('sessionId', data.sessionId,0, 60);
                console.log("createsession - dispatched")
                me.dispatchEvent('createsession',me.sessionId,me.sessionState  );
                resolve(me.sessionId);
            }).catch(error => {
                me.dispatchEvent('createsessionfailed',error );
                reject(error); 
            });
    });

        
}

/*
VcCommunicator.prototype.changeuserpassword=function(config) {
    var me=this;

    return new Promise((resolve, reject) => {
        this.retrieveData(this.createUrl("changeuserpassword"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "Password change failed");
                    return;
                }
                
                resolve(me.sessionId);
            }).catch(error => {
                reject(error); 
            });
    });

}
*/
// Send 2FA verification code
VcCommunicator.prototype.send2FACode = function(context) {
    var me = this;
    
    var config = {
        action: 'send'
    };
    
    // Include any context if provided
    if (context) {
        config.context = context;
    }
    
    return me.retrieveData(this.createUrl("twofactor"), config);
}

// Resend 2FA verification code  
VcCommunicator.prototype.resend2FACode = function(context) {
    var me = this;
    
    var config = {
        action: 'resend'
    };
    
    if (context) {
        config.context = context;
    }
    
    return me.retrieveData(this.createUrl("twofactor"), config);
}

// Verify 2FA code
VcCommunicator.prototype.verify2FACode = function(params) {
    var me = this;
    
    var config = {
        action: 'verify',
        code: params.code
    };
    
    // Include any additional parameters
    Object.keys(params).forEach(function(key) {
        if (key !== 'code') {
            config[key] = params[key];
        }
    });
    
    // Only send deviceName (to register device) if user opted in to "Remember this device"
    if (config.rememberDevice !== false && !config.deviceName) {
        config.deviceName = me.getDeviceName();
    }
    // Don't send rememberDevice flag to server — it's client-only
    delete config.rememberDevice;
    
    return me.retrieveData(this.createUrl("twofactor"), config).then(function(response) {
        // Store the device token returned by the server for future logins
        if (response && response.deviceToken) {
            VcLocationsStorage.setValue('vc2FADeviceToken', response.deviceToken);
        }
        return response;
    });
}

// Get a human-readable device name for 2FA device registration
VcCommunicator.prototype.getDeviceName = function() {
    try {
        var ua = navigator.userAgent || '';
        // Try to extract a meaningful device/browser name
        if (/iPhone/.test(ua)) return 'iPhone';
        if (/iPad/.test(ua)) return 'iPad';
        if (/Android/.test(ua)) return 'Android Device';
        if (/Mac OS/.test(ua)) return 'Mac ' + ((/Chrome/.test(ua) && !/Edg/.test(ua)) ? 'Chrome' : /Safari/.test(ua) ? 'Safari' : /Firefox/.test(ua) ? 'Firefox' : 'Browser');
        if (/Windows/.test(ua)) return 'Windows ' + ((/Chrome/.test(ua) && !/Edg/.test(ua)) ? 'Chrome' : /Edg/.test(ua) ? 'Edge' : /Firefox/.test(ua) ? 'Firefox' : 'Browser');
        if (/Linux/.test(ua)) return 'Linux ' + (/Chrome/.test(ua) ? 'Chrome' : /Firefox/.test(ua) ? 'Firefox' : 'Browser');
        return 'Web Browser';
    } catch (e) {
        return 'Web Browser';
    }
}

VcCommunicator.prototype.submitfeedback=function(feedbackType, rating, comments) {
    var me=this;

    var config={
        feedbackType:feedbackType,
        rating:rating,
        comments:comments
    };

    return me.retrieveData(this.createUrl("submitfeedback"), config);
}
VcCommunicator.prototype.signOut=function() {
    var me=this;
    const sessionId=me.sessionId;
    me.sessionId=null;
    me.sessionState=null;
    me.deleteCookie('sessionId');
    me.dispatchEvent('terminatesession');
    return this.retrieveData(this.createUrl("terminatesession"),  {
        "targetSessionId":sessionId
    });

}
VcCommunicator.prototype.createTimelineRequest=function(defn, location, name, requireKey, contentType, forceGlobalKey, serverRoot) {
    var me=this;

    serverRoot = serverRoot || VcGlobal.SERVER_ROOT;

    function encodeURIComponentIfNotNull(value) {
        return  value?encodeURIComponent(value):value;
    }
    const isPreview=defn && defn.options && VcListUtils.hasValueInList(defn.options, "preview");
    
    location=encodeURIComponentIfNotNull(location);
    name=encodeURIComponentIfNotNull(name);
    var startdate=encodeURIComponentIfNotNull(defn.startdate);
    var enddate=encodeURIComponentIfNotNull(defn.enddate);

    var sessionId=!requireKey && me.sessionId;
    var key=(isPreview && "-") || (forceGlobalKey && VcGlobal.GLOBAL_KEY) ||  defn.key || (!sessionId && me.sessionState && me.sessionState.apiKey);
    contentType=contentType || defn.contentType;

    var queryParams={
       
    }

    if (name) queryParams.locationNames=name;
    if (defn.unitGroup) queryParams.unitGroup=defn.unitGroup;
    if (defn.maxDistance>0) queryParams.maxDistance=defn.maxDistance;
    if (defn.elements) queryParams.elements=defn.elements;
    if (defn.include) queryParams.include=defn.include;
    if (defn.forecastDataset) queryParams.forecastDataset=defn.forecastDataset;
    
    if (sessionId) {
        queryParams.sessionId=sessionId;
    } else if (key) {
        queryParams.key=key;
    } else {
        queryParams.key=VcGlobal.GLOBAL_KEY;
    }


    if (defn.maxStations>0) queryParams.maxStations=defn.maxStations;
    if (defn.elevationDifference>0) queryParams.elevationDifference=defn.elevationDifference;
    if (defn.options) queryParams.options=defn.options;
    if (defn.lang) queryParams.lang=defn.lang;
    if (defn.iconSet) queryParams.iconSet=defn.iconSet;

    if (contentType) queryParams.contentType=contentType;
    if (defn.forecastBasisDate) queryParams.forecastBasisDate=defn.forecastBasisDate;
    if (defn.forecastBasisDay) queryParams.forecastBasisDay=defn.forecastBasisDay;
    		
    if (defn.degreeDayMethod) queryParams.degreeDayMethod=defn.degreeDayMethod;
    if (defn.degreeDayTempFix) queryParams.degreeDayTempFix=defn.degreeDayTempFix;
    if (defn.degreeDayTempMaxThreshold) queryParams.degreeDayTempMaxThreshold=defn.degreeDayTempMaxThreshold;
    if (defn.degreeDayTempBase) queryParams.degreeDayTempBase=defn.degreeDayTempBase;
    if (defn.degreeDayStartDate) queryParams.degreeDayStartDate=defn.degreeDayStartDate;
    if (defn.degreeDayInverse) queryParams.degreeDayInverse=defn.degreeDayInverse;
    var urlParams=new URLSearchParams(queryParams);
    let basePath = isPreview?"/VisualCrossingWebServices/rest/services/timelinepreview/":"/VisualCrossingWebServices/rest/services/timeline/";
   
    var url=serverRoot+basePath+location;

    if (startdate) {
        url+="/"+startdate;
        if (enddate) {
            url+="/"+enddate;
        }
    }

    return url+"?"+urlParams; 
}
VcCommunicator.prototype.retrieveTimelineData=function(defn, location, name,  contentType, requireKey, forceGlobalKey, serverRoot) {
    var me=this;
    
    var request=me.createTimelineRequest(defn, location, name, requireKey, contentType, forceGlobalKey, serverRoot);



    return new Promise((resolve, reject) => {
        var isError=false;
        fetch(request)
            .then(response => {
                if (!response.ok) {
                    isError=true;
                    return response.text();
                }
                if (contentType==="json") {
                    return response.json();
                } else {
                    return response.text();
                }
               
            }).then(jsonOrText =>  {
                if (isError) {
                    reject(jsonOrText);
                    return;
                }
                resolve(jsonOrText);
            }).catch(error =>  {
                reject(error);
            }
            );
    });
/*
    return fetch(request)
        .then(response => {
            if (!response.ok) {
                //throw new Error("Error retrieving the data ("+response.status+")");
                return response.text();
            }
            
            return response.json();
        }); 
    */
}

VcCommunicator.prototype.testTimelineRequest=function(url, data, method, contentType ) {
        let me=this;
        let options;
    
        method=method || "GET";
    
        if (method==="GET" && data) {
            url=url+"?"+data;
            data=null;
        }
    
    
        if (!contentType) {
            if (method==="GET") {
                
            } else if (method==="POST") {
                contentType='application/x-www-form-urlencoded'
            }
        }
        
       
        if (contentType==='application/x-www-form-urlencoded') {
            //data = new URLSearchParams(data);
        } else if (contentType==='application/json') {
          //  data=JSON.stringify(data);
        } else {
    
        }
    
        if (method==="POST") {
            options={
                method: method, 
                mode: 'cors',
                cache: 'no-cache', 
                headers: {
                 'Content-Type': contentType,
                },
                redirect: 'follow', 
                referrerPolicy: 'strict-origin-when-cross-origin',
                body: data
            }
        }
    
        function getResponse(success, message) {
            return {
                success:success,
                message:message
            }
        }
    
        return new Promise((resolve, reject) => {
            try {
            
                let isError=false;
                let status=-1;
            
       
                if (!url || !url.includes("timeline")) {
                    reject(getResponse(false,`Invalid timeline API structure`));
                    return;
                }
        
                fetch(url, options )
                    .then(response => {
                        status=response.status;
                        if (!response.ok) {
                            isError=true;
                            
                            return response.text();
                        }
                        return response.text();
                       
                    })
                    .then(jsonOrText =>  {
                        if (isError) {
                            reject( getResponse(false,`Error: HTTP Status:${status} - ${jsonOrText}`));
                        }
                        
                        let json=null;
                        let preview;
                        try {
                            json = JSON.parse(jsonOrText);
                            preview="Successful JSON response";
                        } catch (e) {
                            preview="Successful text response";
                        }
    
    
                        resolve(getResponse(true,`Successful: HTTP Status:${status} - ${preview}`));
                    }).catch(error =>  {
                        error=(error && error.essage) || "Unexpected error submitting the request";
                        reject(getResponse(false,`Unhandled HTTP error likely caused by invalid URL structure. ${error}`));
                    }
                    );
            } catch (e) {
                 reject(getResponse(false,`Error submitting request: ${e}`));
            }
        });
    }


/*
VcCommunicator.prototype.retrieveWeatherData=function(querytype,locations,params, callback) {
    var me=this;
    var tableId="WxSourceData";
    var table={
        "name" : tableId,
        "id" : tableId,
        "isPrimary" : true,
        "analyzeLevels" : false,
        "columns" : [],
        "rows" : [],
        layerDataContext:{
            "FieldJoins" : "{}",
            "useGeoJsonGeometry" : "true",
            "attributeId" : "name",
            "shapeType" : "1",
            "onDemandTileGeneration" : "true",
            "joinLayerColumns" : "address",
            "contextType" : "6",
            "attributeName" : "",
            "FieldValues" : "{}",
            "addressFields" : "address"
        }
    }
 
    table.columns.push( {
        "isKey" : true,
        "name" : "Name",
        "id" : "name",
        "type" : "string",
        "defaultNumberAggregateStyle" : -1,
        "format" : "!"							
    });
    table.columns.push( {
        "isKey" : false,
        "name" : "Address",
        "id" : "address",
        "type" : "string",
        "defaultNumberAggregateStyle" : -1,
        "format" : "!"							
    });


 

    locations.forEach(function(location) {
        table.rows.push([location.name, location.address]);
    });


    var weatherRequest=new Metadata();
    weatherRequest.addData(0, VisualCrossingConstants.DATA_PROVIDER_TYPE.JSONDATASOURCETABLE);
    weatherRequest.addData(1, VisualCrossingConstants.DATA_PROVIDER_TYPE.WEATHERJOINDATASOURCETABLE);

    weatherRequest.addDataProperty(1, VisualCrossingConstants.WEATHER.DATASET_TYPE, VisualCrossingConstants.WEATHER_DATASET_TYPE.goalTypeFromName(querytype));
    
    Object.keys(VisualCrossingConstants.WEATHER).forEach(function(d) {
        var prop=VisualCrossingConstants.WEATHER[d];
        if (params[prop]) {
            weatherRequest.addDataProperty(1,prop, params[prop]);
        }
    });
 
    
    me.processObject(weatherRequest,table, {
        "done":function(data) {
            data=VcUtils.transformDatasource(data);
            callback.done(data);
        },
        "update":function(data) {
            callback.update(data);
        },
        "fail":function(data) {
            callback.fail(data || "Weather data retrieval failed");
        }
    
    });
    
}
*/
